const loginWithReturnUrl = '/login?ReturnUrl=';
const loginCheckoutWithReturnUrl = '/logincheckout?ReturnUrl=';
const getLocationFromGoogleMapsAPIPath = 'https://www.googleapis.com/geolocation/v1/geolocate?key=';
export default {
  loginWithReturnUrl,
  loginCheckoutWithReturnUrl,
  getLocationFromGoogleMapsAPIPath,
};
